// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1wDrn","file":"styles_file__1as9s"};